import type { Contact } from "@/interfaces/contact";
import { httpClient } from "@/lib/api";
import { ContactFilters } from "@/types/filters/contact";
import { serializeSearchParams } from "@/utils/serializeSearchParams";

export type ListContactsResponse = {
  data: Contact[];
  total: number;
  hasMore: boolean;
  rowCount: number;
};

type CreateContactDto = {
  name: string;
  phone: string;
  email?: string;
  tagIds?: number[];
};

type ChangeDepartmentDto = {
  tagIds: number[];
}

export class ContactService {
  public static async list(params: ContactFilters = {}) {
    const searchParams = new URLSearchParams(serializeSearchParams(params));
    const { data } = await httpClient().get<ListContactsResponse>(`/contact?${searchParams}`);
    return data;
  }

  public static async create(payload: CreateContactDto) {
    const { data } = await httpClient().post<Contact>(`/contact`, payload);
    return data;
  }

  public static async update(id: number, payload: CreateContactDto) {
    const { data } = await httpClient().patch<Contact>(`/contact/${id}`, payload);
    return data;
  }

  public static async changeSegments(id: number, payload: ChangeDepartmentDto) {
    const { data } = await httpClient().patch<Contact>(`/contact/${id}/segment`, payload);
    return data;
  }

  public static async delete(id: number) {
    const { data } = await httpClient().delete<Contact>(`/contact/${id}`);
    return data;
  }

  public static async importContacts(payload: FormData) {
    const { data } = await httpClient().post<{ created: number; }>(`/contact/import`, payload);
    return data;
  }
}
